// @flow
import createUniversalRoute from "../../utils/createUniversalRoute";
import marketingRoutes from "../../pages/MarketingLayout/routes";
import onboardingRoutes from "../../pages/OnboardingLayout/routes";

const routes = [
  {
    path: "/virtual-tours/:id",
    name: "VirtualTour",
  },
  {
    path: "/for-sale/:postcodeSector/:roadName/:dealExternalId/enquiry",
    name: "PropertyEnquiry",
  },
  {
    path: "/callback/login",
    name: "LoginCallback",
  },
  {
    path: "/book-a-call",
    name: "OnboardingLayout",
    routes: onboardingRoutes,
  },
  {
    path: "/",
    name: "MarketingLayout",
    routes: marketingRoutes,
  },
];

export default routes.map<*>(createUniversalRoute);
